import React from 'react';
import '../Styles/Clients.css';
import { FaRegWindowMaximize } from 'react-icons/fa';
import ICOAX from '../Assets/ICOAX.png';
import Exotic from '../Assets/MrMiami.png';
import Xbuilds from '../Assets/Xbuilds.png';


const Clients = () => {
  return (
    <>
      <main className='client__container' id='clients'>
        <div className='client'>
          <img src={Exotic} className='miami' alt='Homepage of blue and black tools' />
          <div className='client__overlay'>
            <div className='client__text'>
              <h2> Exotic Express </h2>
              <p> CRA for Miami based handy man, where users are able to view past projects and services,as well as, schedule and pay for consultation </p>
              <div className='links'>
                <a href='https://www.icoax.org/' target='_blank' rel='noreferrer'> <FaRegWindowMaximize /> </a>
              </div>
              <span> Work in progress </span>
            </div>
          </div>
        </div>
        <div className='client'>
          <img src={ICOAX} alt='Orange header with white background and owner wearing white shirt while crossing her arms' />
          <div className='client__overlay'>
            <div className='client__text'>
              <h2> Intercambio </h2>
              <p> CMS based website in spanish that details about a young woman named Yulissa and her amazing orchestra </p>
              <div className='links'>
                <a href='https://www.icoax.org/' target='_blank' rel='noreferrer'> <FaRegWindowMaximize /> </a>
              </div>
              <span> Constantly adding new elements </span>
            </div>
          </div>
        </div>
        <div className='client'>
         <img src ={Xbuilds} alt='a dark background of a wood saw with white text'/>
          <div className='client__overlay'>
            <div className='client__text'>
              <h2> XBuilds </h2>
              <p> Simple vanilla JavaScript project for a woodcrafter </p>
              <div className='links'>
                <a href='https://powerpuffapi.netlify.app'> <FaRegWindowMaximize /> </a>
              </div>
              <span> Is not hosted anywhere, on hold; waiting for client </span>
            </div>
          </div>
        </div>

      </main>
    </>
  )
}

export default Clients;